export default __webpack_public_path__ + "static/media/logo.ffe6fdfb.png";